<div *ngIf="technicianInfoFG" class="technician-info-container component-container">
  <app-review-section
    #technicianSection
    [title]="'personal-data.form-details.technician-info-title' | translate"
    [tooltip]="'tooltips.personal-data.technician-info' | translate"
    [sectionId]="TechnicianSectionIdentifier"
    [applicationId]="applicationId"
    [isDetailsView]="isDetailsView"
    [showAcceptRejectButtons]="false"
    [showButtonsPredicate]="hideButtonsForChimneySweeper">
    <form [formGroup]="technicianInfoFG" class="ui-g-12 form-section form-font-size">
      <div class="ui-g-12">
        <div class="ui-g form-rows">
          <div *ngIf="!showBdewIdField" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <label class="ui-g-5 field-label text-right-align" for="technician-id">
              {{ 'personal-data.form-details.fields.technician-id' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              formControlName="technicianId"
              id="technician-id"
              pInputText
              size="30"
              type="text"
              [readonly]="!technicianSection.isDataEditable" />
          </div>
          <div *ngIf="showBdewIdField" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <label class="ui-g-5 field-label text-right-align" for="bdew-id">
              {{ 'personal-data.form-details.fields.bdew-id' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              formControlName="bdewId"
              id="bdew-id"
              pInputText
              size="30"
              type="text"
              [readonly]="!technicianSection.isDataEditable" />
          </div>
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <label class="ui-g-5 field-label text-right-align" for="technician-company">
              {{ 'personal-data.form-details.fields.company-name' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              formControlName="companyName"
              id="technician-company"
              maxlength="5"
              pInputText
              size="30"
              type="text"
              [readonly]="!technicianSection.isDataEditable" />
          </div>
        </div>

        <div class="ui-g form-rows">
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <label class="ui-g-5 field-label text-right-align" for="technician-firstname">
              {{ 'personal-data.form-details.fields.first-name' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              formControlName="firstName"
              id="technician-firstname"
              pInputText
              size="30"
              type="text"
              [readonly]="!technicianSection.isDataEditable" />
          </div>
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <label class="ui-g-5 field-label text-right-align" for="technician-telephone">
              {{ 'personal-data.form-details.fields.info-telephone' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              formControlName="telephone"
              id="technician-telephone"
              pInputText
              [readonly]="!technicianSection.isDataEditable" />
          </div>
        </div>

        <div class="ui-g form-rows">
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <label class="ui-g-5 field-label text-right-align" for="technician-lastname">
              {{ 'personal-data.form-details.fields.last-name' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              formControlName="lastName"
              id="technician-lastname"
              maxlength="5"
              pInputText
              size="30"
              type="text"
              [readonly]="!technicianSection.isDataEditable" />
          </div>
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <label class="ui-g-5 field-label text-right-align" for="technician-email">
              {{ 'personal-data.form-details.fields.email' | translate }}
            </label>
            <input
              class="ui-input pInputText input-field"
              id="technician-email"
              formControlName="email"
              pInputText
              size="30"
              type="email"
              [readonly]="!technicianSection.isDataEditable" />
          </div>
        </div>
      </div>
    </form>
  </app-review-section>
</div>
